import { ElementDetails } from "@/lib/types";

export const details = {
  name: "Quotes",
  description: "Displays an inspirational quote",
  category: "Widget",
  grid: { default: [4, 1] },
  defaultProps: {},
  fields: [],
} satisfies ElementDetails;
